
export default function compareClassInit(coreHandlerInstance) {
  const targetClassName = ".js__compare-item";
  const apiParam = "&CULTURE=";


  class compareClass {
    static compareList = [];
    static callUrl = "https://catalog.ulprospector.com/Datasheet.aspx?I=68506&E=";
    static outputArea = document.getElementById("js__compare-list");
    static outputAreaBody = document.getElementById("js__compare-list-body");
    static execButton = document.getElementsByClassName("js__compare-btn");
    static resetButton = document.getElementById("js__compare-reset-btn");
    // static apiLanguage = compareClass.outputArea.getAttribute('data-api-language') || null;
    static coreHandler = coreHandlerInstance;
    static rebuildFunc = null
    static resetInit = () => {
      return compareClass.resetButton.addEventListener("click", () => {
        [...document.querySelectorAll(targetClassName)].map(v => {
          v.classList.remove("is-selected");
          v.querySelector("input").checked = false;
        });
        while (compareClass.outputAreaBody.firstChild) {
          compareClass.outputAreaBody.removeChild(compareClass.outputAreaBody.firstChild);
        }
        compareClass.outputArea.style.display = "none";
        compareClass.compareList = [];
        compareClass.coreHandler.resetCompareList();
      });
    };

    static execInit = () => {
      return [...compareClass.execButton].map(e => e.addEventListener("click", () => {
        let productCompareList = compareClass.callUrl + compareClass.compareList.join('~');
        productCompareList = productCompareList + compareClass.setLanguageCultureParam();
        open(productCompareList);
      }));
    }
    static init = () => {
      this.instanceList = [...document.querySelectorAll(targetClassName)].map(v => new compareClass(v));
      compareClass.resetInit();
      compareClass.execInit();
    }
    static rebuild = () => {
      this.instanceList = [...document.querySelectorAll(targetClassName)].map(v => new compareClass(v));
    }

    /**
     * データシートのパラメータに言語設定を追加する関数
     * ※wovnでlang設定が変わるため、比較イベント時に再度htmlのlang属性を取得すること
     * @return [string] - データシートの仕様に沿った言語設定のCULTUREパラーメータ
     */
    static setLanguageCultureParam = () => {
      let html = document.querySelector("html");
      let langAttr = html.getAttribute("lang");
      if(!langAttr) langAttr = "ja";

      return apiParam + langAttr;
    }

    constructor(ele) {
      this.instanceType = "compareClass";
      this.ele = ele;
      this.instanceList = null;
      this.entryId = Number(this.ele.getAttribute("data-entry-id")) || null;
      this.label = this.ele.getAttribute("data-label") || null;
      this.input = this.ele.querySelector('input')
      this.clickHandler = this.clickEvent.bind(this);
      this.input.addEventListener("click", this.clickHandler);
    }
    clickEvent = () => {
      this.handleCompareItem();
    };

    handleCompareItem = () => {
      if (!this.ele.classList.contains("is-selected") && compareClass.compareList.indexOf(this.input.value)) {
        this.ele.classList.add("is-selected");
        compareClass.compareList.push(this.input.value);
        compareClass.coreHandler.setCompareList(this.input.value);
        this.addCompareList();
      } else {
        this.ele.classList.remove("is-selected");
        this.input.checked = false;
        this.removeLabel();
        const index = compareClass.compareList.indexOf(this.input.value);
        compareClass.compareList.splice(index, 1);
        compareClass.coreHandler.removeCompareList(this.input.value);
      }
    };

    addCompareList = () => {
      const labelText = this.label ? this.label : "エラー";
      const newButton = document.createElement("button");
      newButton.className = "p-label p-label--compare js__compare-label";
      newButton.setAttribute('data-entry-id', this.input.value);

      let newSpan = document.createElement("span");
      newSpan.innerHTML = "<span class=\"material-icons-outlined p-material-icon\">close</span> " + labelText;
      newButton.appendChild(newSpan);
      compareClass.outputAreaBody.appendChild(newButton);
      compareClass.outputArea.style.display = "flex";

      newButton.addEventListener("click", () => {
        this.clickEvent();
      }, true);
    };

    removeLabel = () => {
      let labelList = compareClass.outputArea.querySelectorAll(".js__compare-label");
      let removeItemSearch = [...labelList].filter(v => {
        return Number(v.getAttribute("data-entry-id")) === this.entryId;
      })
      if (removeItemSearch) {
        compareClass.outputAreaBody.removeChild(removeItemSearch[0]);
      }
      labelList = compareClass.outputArea.querySelectorAll(".js__compare-label");
      if (labelList.length < 1) {
        compareClass.outputArea.style.display = "none";
      }
    };


  }
  compareClass.init();
  return compareClass;
}